export default __webpack_public_path__ + "static/media/skills1.e9c1bf1f.png";